import fetch from 'services/request';
import storage from 'utils/sessionStorage';
import { IFeedbackReviewPayload } from './types/api';

export const getShopInfo = (shopId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/getInfoDetail',
    shopId,
  });
};

export const getStaffs = (shopId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/staff/get-all-by-shop',
    params: {
      size: 1000,
    },
    shopId
  });
};
export const getStaffsBookingOnline = (shopId: string, customer_id?: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/staff/available-booking-online',
    shopId,
    params: customer_id ? {
      customer_id,
    } : {}
  });
};


export const getCategories = (shopId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/category/get-all-booking',
    shopId
  });
};

export const getCategoriesByStaff = (staffId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/category/get-all-booking',
    shopId: storage.shop_id.get(),
    params: {
      staffId,
    }
  });
};

const getQuickServices = (shopId: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/service/quick-booking',
    shopId
  });
};

const getShopAllSetting = (shopId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/tablet/check-in/setting',
    shopId,
  });
};

const getDetailCoupon = (shopId: string, couponId: string) => {
  return fetch({
    method: 'get',
    url: `api/v1/coupon/detail/${couponId}`,
    shopId
  });
};

const getReviewDetail = (shopId: string, reviewId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/review/detail/' + reviewId,
    shopId,
  });
};

const updateChannelReview = (reviewId: string, channel: string) => {
  return fetch({
    method: 'post',
    url: 'api/v1/review/update-channel-review',
    body: { reviewId, channel },
    autoToast: true,
  });
};

const getSocialMedia = (shopId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/review/social-media',
    shopId,
  });
};

const allShopSetting = (shopId?: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/all-setting',
    shopId,
  });
};
const getNotification = (shopId?: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/notification',
    shopId,
  });
};

const getSettingDepositBooking = (shopId?: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/shop/setting-deposit-booking',
    shopId,
  });
};

const getServicesByCategory = (shopId?: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/category/get-all-by-category',
    shopId,
  });
};

const feedbackReview = (body: IFeedbackReviewPayload) => {
  return fetch({
    method: 'post',
    url: 'api/v1/review/feedback-review',
    body,
  });
};

const getCustomServicePricesByStaff = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/staff/service-price-all',
  });
};

const shopApis = {
  getShopInfo,
  getStaffs,
  getStaffsBookingOnline,
  getCategories,
  getCategoriesByStaff,
  getDetailCoupon,
  getReviewDetail,
  getSocialMedia,
  updateChannelReview,
  getQuickServices,
  getShopAllSetting,
  allShopSetting,
  getSettingDepositBooking,
  getNotification,
  getServicesByCategory,
  feedbackReview,
  getCustomServicePricesByStaff,
};

export default shopApis;
